angular.module('dnecom').directive('statisticsOverviewNumber', function() {
    return {
        restrict: 'EA',
        scope: {
            item: '=item',
            currency: '='
        },
        link: function(scope) {
            if (scope.item.hasOwnProperty('rate')) {
                scope.rate = scope.item.rate.toFixed(2);
            } else if (scope.item.hasOwnProperty('price')) {
                scope.number = Math.floor(scope.item.price);
                scope.fraction = scope.item.price.toFixed(2).toString().split('.')[1] || '00';

                scope.getValue  = function() {
                    return scope.number + '.' + scope.fraction;
                }
            }
        },
        template: [
            '<span ng-if="rate">{{ rate }}%</span>',
            '<span ng-if="number || fraction"><currency-display value="getValue()" currency="currency"></currency-display></span>'
        ].join('')
    };
});
